import React, { useState, useEffect } from 'react';
import localforage from "localforage";
// import { observer } from 'mobx-react-lite';
const FORAGE_KEY = 'previously-on';

type RecentType = {
    key: string;
    type: string;
};

type RecentsContextType = {
    recents: RecentType[];
    addRecent?: (recent: RecentType) => void;
    clearRecents: () => void;
}

export const RecentsContext = React.createContext<RecentsContextType>({
    recents: [] as RecentType[],
    clearRecents: () => { throw "Not  implemented" }
});

export const RecentsProvider = function({ children }: { children: React.ReactNode })  {
    const [recents, setRecents] = useState([] as RecentType[]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if(!loaded) {
            setLoaded(true);
            localforage.getItem<RecentType[]>(FORAGE_KEY).
                then((data) => {
                    setRecents(data || [] as RecentType[]);
                });
        }
    }, [loaded, setLoaded]);

    function addRecent({ key, type }: RecentType) {
        const existing = recents.filter(recent => recent.key !== key);
        const a = [{ "key": key, "type": type }, ...existing].slice(0, 5);

        localforage.setItem(FORAGE_KEY, a);
        setRecents(a);
    }

    function clearRecents() {
        localforage.removeItem(FORAGE_KEY);
        setRecents([]);
    }

    const data = {
        recents: recents,
        addRecent: addRecent,
        clearRecents: clearRecents
    };

    return (
        <RecentsContext.Provider value={data}>{ children }</RecentsContext.Provider>
    );

};
